import { render } from "./organizationChild.vue?vue&type=template&id=53ea72f0&scoped=true"
import script from "./organizationChild.vue?vue&type=script&lang=js"
export * from "./organizationChild.vue?vue&type=script&lang=js"

import "./organizationChild.vue?vue&type=style&index=0&id=53ea72f0&lang=scss&scoped=true"
import "./organizationChild.vue?vue&type=style&index=1&id=53ea72f0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ea72f0"]])

export default __exports__